var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WrappingComponent',{attrs:{"settings":_vm.settings,"formData":_vm.form}})
}
var staticRenderFns = []

export { render, staticRenderFns }